import { render, staticRenderFns } from "./BuscaCep.vue?vue&type=template&id=908a32a6&"
import script from "./BuscaCep.vue?vue&type=script&lang=js&"
export * from "./BuscaCep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports